import Sprite from "../sprite/Sprite";

export default class TileTypeBackground {
    constructor() {
        /**
         * @type {Array.<Sprite>}
         */
        this.sprites = [];
    }
}